import React from "react";
import { Redirect, Route } from "react-router-dom";

import Layout from "../components/shared/layout/Layout";
import { connect } from "react-redux";
import LayoutAdvisor from "../components/shared/layout/LayoutAdvisor";
import { useHelpChat } from "../hooks/useHelpChat";
import LayoutAdmin from "../components/shared/layout/LayoutAdmin";
// import Layout from "../components/shared/layout/Layout";

const PrivateRoute = (props) => {
	const { component: Component, isAuthenticated, rol, user, ...rest } = props;

	useHelpChat(user, isAuthenticated, 'private')

	if (rol === 'administrator') {
		return <Route
			{...rest}
			component={(props) =>
				isAuthenticated ? (
					<LayoutAdmin>
						<Component {...props} />
					</LayoutAdmin>
				) : (
					<Redirect to="/auth/login" />
				)
			}
		/>
	}

	if (rol === 'adviser') {
		return <Route
			{...rest}
			component={(props) =>
				isAuthenticated ? (
					<LayoutAdvisor>
						<Component {...props} />
					</LayoutAdvisor>
				) : (
					<Redirect to="/auth/login" />
				)
			}
		/>
	}

	// RETURN
	return (
		<Route
			{...rest}
			component={(props) =>
				isAuthenticated ? (
					<Layout>
						<Component {...props} />
					</Layout>
				) : (
					<Redirect to="/auth/login" />
				)
			}
		/>
	);
};

const mapStateToProps = (state) => ({
	isAuthenticated: !!state.auth.authToken,
	user: state.auth.user,
	rol: state.auth.rol
});

export default connect(mapStateToProps)(PrivateRoute);
